import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import ReactTable from 'react-table';
import getSortHeaderProps from '../../utils/get-sorted-headers';
import { withTranslation } from 'react-i18next';
import { getExpandedConstituentUnit } from '../../utils/get-expanded-constituent-unit';

class MixDesignTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: [{id: 'order', desc: false}],
      id: null,
    };
  }

  getColumns = () => {
    const { sorted } = this.state;
    const { materialStore, t } = this.props;

    return [
      {
        headerText: t('Constituent'),
        accessor: d => materialStore.getConstituentName(d),
        id: 'constituentItemCode',
        className: 'sticky',
        headerClassName: 'sticky',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Qty'),
        accessor: 'quantity',
        id: 'quantity',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Unit'),
        id: 'unitSymbol',
        accessor: constituent => {
          return getExpandedConstituentUnit(constituent, materialStore);
        },
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Order'),
        accessor: 'order',
        id: 'order',
        ...getSortHeaderProps(sorted),
      },
    ];
  };

  render() {
    const { mixStore, mixId } = this.props;
    const { mixDesigns } = mixStore;
    const id = mixId ? Number(mixId) : null;
    const m = mixDesigns.filter(v => v.mixItemId === id);
    const data = m.length ? m : mixStore.getMixDesign(id);

    return (
      <div>
        <ReactTable
          className={'-highlight'}
          data={data}
          noDataText={''}
          columns={this.getColumns()}
          sorted={this.state.sorted}
          onSortedChange={sorted => this.setState({ sorted })}
          showPaginationTop={false}
          showPaginationBottom={false}
          showPageSizeOptions={false}
          resizable={false}
          minRows={1}
          defaultPageSize={50}
        />
      </div>
    );
  }
}

export default withTranslation()(inject('mixStore', 'materialStore')(observer(MixDesignTable)));
